export const SET_SDE_ANALYSIS_REPORT = "SET_SDE_ANALYSIS_REPORT";
export const SET_HDE_ANALYSIS_REPORT = "SET_HDE_ANALYSIS_REPORT";
